import {Coverage} from './Coverage';
import {Operation} from './Operation';
import {User} from './User';

export const items = {
  User,
  Operation,
  Coverage,
};
